module.exports = __webpack_public_path__ + "img/yang.6f1551d1.png";